import { Directive, OnInit, EventEmitter, Output, ElementRef, Input } from '@angular/core';
import { DeviceService } from '../../services/device.service';

declare const Modernizr: any;

declare const $: any;
@Directive({
    selector: '[gawebScrollToOn]'
})
export class ScrollToOnDirective implements OnInit {
    @Input() scrollToOn: string;
    @Input() scrollToEvent: string;
    @Input() scrollToCss: string;

    private $input: any;
    private element: ElementRef;

    constructor(private _element: ElementRef,
                private deviceService: DeviceService) {
        this.element = _element;
    }

    ngOnInit() {
        if (!this.deviceService.IsMobile()) {
            return;
        }

        const $input = $(this._element.nativeElement);

        if (this.scrollToOn === 'init') {
            // are we inside a modal?
            if ($('.modal-body').is(':visible')) {
                $('.modal-body')
                    .animate({
                        scrollTop: $input.offset().top - 90
                    },
                        500);
            } else {
                $('html, body')
                    .animate({
                        scrollTop: $input.offset().top - 90
                    },
                        500);
            }
        }

        if (this.scrollToOn === 'focus') {
            // handle Focus event
            $input.on('focus',
                () => {

                    const isDesktop = Modernizr
                        .mq('(min-width: 768px)'); //should match: .less @screen-sm-min

                    if (!isDesktop) {
                        $('.booking-wgt')
                            .animate({
                                scrollTop: $input.offset().top - 60
                            },
                                500);
                    }
                });
        }

        if (this.scrollToOn === 'event') {
            const cssName = this.scrollToCss;
            const eventName = this.scrollToEvent,
                action = () => {
                    $('html, body')
                        .animate({
                            scrollTop: $(`.${cssName}`).offset().top
                        },
                            500);
                };

            /* const closeEventListener = $rootScope.$on(eventName, action);
            scope.$on('$destroy',
                () => {
                    closeEventListener();
                }); */
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/scroll-to-on/scroll-to-on.directive.ts